import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b29cb03c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b29cb03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29cb03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b29cb03c')) {
      api.createRecord('b29cb03c', component.options)
    } else {
      api.reload('b29cb03c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b29cb03c&scoped=true&", function () {
      api.rerender('b29cb03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oCOW5SAsNeQR/JS/comp/DocBox.vue"
export default component.exports